module.exports = __webpack_public_path__ + "img/IT.8a7e317f.svg";